export default __webpack_public_path__ + "v3.416/facebook-logo.png";